"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _createNamedExportFrom(obj, localName, importedName) { Object.defineProperty(exports, localName, {enumerable: true, configurable: true, get: () => obj[importedName]}); } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }



var _types = require('./types');

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _pins = require('shared/services/pins');

var _map = require('shared/services/map');
var _array = require('shared/services/array');

 const LOAD_LIMIT = 30; exports.LOAD_LIMIT = LOAD_LIMIT

const TAB_WRAPPED_TYPES = {
  [_types.InboxTab.PATIENTS]: ['patient_conversation', 'sms_patient_conversation'],
  [_types.InboxTab.TEAM]: ['chat'],
}



// The GetInbox fields for a tab. All adds none, so its request is today's.
 const tabRequestFields = (tab) => {
  if (tab === _types.InboxTab.UNREAD) return { UnreadOnly: true }
  if (tab === _types.InboxTab.SCHEDULED) return { ScheduledOnly: true }
  if (tab === _types.InboxTab.REQUESTS) return { RequestsOnly: true }
  const WrappedTypes = TAB_WRAPPED_TYPES[tab]
  return WrappedTypes ? { WrappedTypes } : {}
}; exports.tabRequestFields = tabRequestFields

// The server's Unread rule, and the one that bolds a row.
var _unread = require('shared/services/unread'); _createNamedExportFrom(_unread, 'isUnreadForMe', 'isUnreadForMe');
 const EMPTY_BLOBJECT_MAP = {}; exports.EMPTY_BLOBJECT_MAP = EMPTY_BLOBJECT_MAP
 const keyExtractor = (b) => b.Key; exports.keyExtractor = keyExtractor

 const resetActions = [
  _actionCreators2.default.setTeamInboxSettingsActions.SUCCESS.type,
  _actionCreators2.default.createConversationActions.SUCCESS.type,
  _actionCreators2.default.createSmsConversationActions.SUCCESS.type,
  _actionCreators2.default.setBlobjectCompletedForTeamsActions.SUCCESS.type,
]; exports.resetActions = resetActions
 const updateActions = [_actionCreators2.default.updateNotificationAction.type]; exports.updateActions = updateActions
// Sent when you lose access to chats, e.g. you're removed from one.
 const purgeActions = [_actionCreators2.default.purgeNotificationAction.type]; exports.purgeActions = purgeActions















 const filterRelevantBlobjects = ({
  action,
  activeFilter,
  activeTab = _types.InboxTab.ALL,
  myUserKey,
  myInboxableTeamKeys,
  selectedTeamKey,
}) => {
  const tabTypes = TAB_WRAPPED_TYPES[activeTab]
  const { Blobjects = exports.EMPTY_BLOBJECT_MAP } = action.payload

  const [relevantBlobjectsList, rejectedBlobjectList] = _array.splitBy.call(void 0, 
    Object.values(Blobjects),
    b => {
      if (tabTypes && !tabTypes.includes(b.WrappedType)) return false

      const userSubscriber = b.UserSubscribers[myUserKey]
      const userMetadata = b.UserMetadata[myUserKey] 

      if (!userSubscriber || selectedTeamKey) {
        const teamsList = Object.values(b.TeamSubscribers)
        if (
          activeFilter === _types.BlobjectFilter.ACTIVE && teamsList.every(t => t.Completed)
          || activeFilter === _types.BlobjectFilter.COMPLETED && teamsList.every(t => !t.Completed)
        ) return false
      }

      if (userMetadata) {
        if (
          activeFilter === _types.BlobjectFilter.ACTIVE && userMetadata.Completed
          || activeFilter === _types.BlobjectFilter.COMPLETED && !userMetadata.Completed
        ) return false
      }

      if (selectedTeamKey) return !!b.TeamSubscribers[selectedTeamKey]
      return !!(userSubscriber || myInboxableTeamKeys.some(tk => b.TeamSubscribers[tk]))
    },
  )

  return [
    _map.listToMap.call(void 0, relevantBlobjectsList, exports.keyExtractor),
    rejectedBlobjectList,
  ]
}; exports.filterRelevantBlobjects = filterRelevantBlobjects

// The sub-millisecond digits of an RFC 3339 time, which Date drops.
const subMilliseconds = (time) =>
  Number((_nullishCoalesce(_optionalChain([/\.(\d+)/, 'access', _ => _.exec, 'call', _2 => _2(time), 'optionalAccess', _3 => _3[1]]), () => ( ''))).slice(3, 9).padEnd(6, '0'))

// Newest first, in the backend's paging order: full-precision sort time,
// then key.
 const compareBlobjectDates = (a, b) =>
  +new Date(b.InboxSortTime) - +new Date(a.InboxSortTime)
  || subMilliseconds(b.InboxSortTime) - subMilliseconds(a.InboxSortTime)
  || (a.Key < b.Key ? 1 : a.Key > b.Key ? -1 : 0); exports.compareBlobjectDates = compareBlobjectDates

// The order of every inbox list: my pinned chats first, the most recently
// pinned at the top, then the rest newest first (compareBlobjectDates).
 const makeCompareInboxRows = (myUserKey) => (a, b) => {
  const pinnedA = _pins.myPinnedAt.call(void 0, a, myUserKey)
  const pinnedB = _pins.myPinnedAt.call(void 0, b, myUserKey)
  if (pinnedA && pinnedB) {
    return +new Date(pinnedB) - +new Date(pinnedA)
      || subMilliseconds(pinnedB) - subMilliseconds(pinnedA)
      || exports.compareBlobjectDates.call(void 0, a, b)
  }
  if (pinnedA) return -1
  if (pinnedB) return 1
  return exports.compareBlobjectDates.call(void 0, a, b)
}; exports.makeCompareInboxRows = makeCompareInboxRows

 const pinActions = [
  _actionCreators2.default.setBlobjectPinnedActions.REQUEST.type,
  _actionCreators2.default.setBlobjectPinnedActions.SUCCESS.type,
  _actionCreators2.default.setBlobjectPinnedActions.FAILURE.type,
]; exports.pinActions = pinActions
 const pinPhase = (type) =>
  type === exports.pinActions[0] ? 'request' : type === exports.pinActions[1] ? 'success' : 'failure'; exports.pinPhase = pinPhase






// Whether a chat sorts after the cursor, i.e. on a page not loaded yet.
// Without a cursor no page has been asked for past the first, so nothing is.
 const isPastCursor = (b, cursor) =>
  !!cursor && exports.compareBlobjectDates.call(void 0, b, { InboxSortTime: cursor.Before, Key: cursor.BeforeKey || '' } ) > 0; exports.isPastCursor = isPastCursor

 const getEarliestBlobjectTime = (bs, baseTime) =>
  bs.reduce(
    (acc, b) => {
      const d = new Date(b.InboxSortTime)
      return !acc || d < acc ? d : acc
    },
    baseTime,
  ); exports.getEarliestBlobjectTime = getEarliestBlobjectTime
